var _rect, _path;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgHomeDrop(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 44,
    height: 44,
    viewBox: "0 0 44 44",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 44,
    height: 44,
    rx: 8,
    fill: "#F1F5F9",
    fillOpacity: 0.5
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M28.8486 15.1515C29.3172 15.6201 29.3172 16.3799 28.8486 16.8485L22.8486 22.8485C22.3799 23.3172 21.6202 23.3172 21.1515 22.8485L15.1515 16.8485C14.6829 16.3799 14.6829 15.6201 15.1515 15.1515C15.6202 14.6828 16.3799 14.6828 16.8486 15.1515L22 20.3029L27.1515 15.1515C27.6202 14.6828 28.3799 14.6828 28.8486 15.1515ZM28.8486 22.3515C29.3172 22.8201 29.3172 23.5799 28.8486 24.0485L22.8486 30.0485C22.3799 30.5172 21.6201 30.5172 21.1515 30.0485L15.1515 24.0485C14.6829 23.5799 14.6829 22.8201 15.1515 22.3515C15.6202 21.8828 16.3799 21.8828 16.8486 22.3515L22 27.5029L27.1515 22.3515C27.6202 21.8828 28.3799 21.8828 28.8486 22.3515Z",
    fill: "white"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHomeDrop);
export default __webpack_public_path__ + "static/media/home-drop.a75848f8cdd81fc315920aa7682b55dc.svg";
export { ForwardRef as ReactComponent };